import {
   CORE_LOAD_ROOMSTATUS_REQUEST,
   CORE_LOAD_ROOMSTATUS_SUCCESS,

   CORE_LOAD_ROOMS_REQUEST,
   CORE_LOAD_ROOMS_SUCCESS,
} from '../types'

export default {
   roomStatus: (state = [], action) => {
      switch (action.type) {
         case CORE_LOAD_ROOMSTATUS_REQUEST:
            return state
         case CORE_LOAD_ROOMSTATUS_SUCCESS:
            if (action.payload) {
               const payLoad = action.payload
               return payLoad
            }
            else return {}
         default:
            return state
      }
   },
   rooms: (state = [], action) => {
      switch (action.type) {
         case CORE_LOAD_ROOMS_REQUEST:
            return state
         case CORE_LOAD_ROOMS_SUCCESS:
            if (Array.isArray(action.payload)) {
               const payLoad = action.payload
               return payLoad
            }
            else return []
         default:
            return state
      }
   },
}



// WEBPACK FOOTER //
// ./src/display/reducers/reducerRoom.js